export default "# beA auf iPhone & iPad - Anwaltspostfach - beA\n\nEinfacher und sicherer Zugriff auf das Anwaltspostfach per App\n";